import React from "react";

const AgentBioModal = ({ agent, isOpen, onClose }) => {
  if (!isOpen || !agent) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white p-4 sm:p-6 md:p-8 rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto my-4">
        <div className="flex justify-between items-start gap-4 mb-4">
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">{agent.name}</h2>
            <p className="text-red-600 font-semibold mt-1">{agent.title}</p>
          </div>
          <button onClick={onClose} className="flex-shrink-0 min-w-[44px] min-h-[44px] flex items-center justify-center text-2xl font-bold text-gray-500 hover:text-gray-700 touch-manipulation" aria-label="Close">&times;</button>
        </div>
        <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 text-gray-700 leading-relaxed">
          {agent.fullBio}
        </p>
        {(agent.email || agent.phone) && (
          <div className="border-t pt-4 space-y-1 text-gray-600">
            {agent.email && <p><a href={`mailto:${agent.email}`} className="text-red-600 hover:underline">{agent.email}</a></p>}
            {agent.phone && <p><a href={`tel:${agent.phone.replace(/\D/g, "")}`} className="text-red-600 hover:underline">{agent.phone}</a></p>}
          </div>
        )}
      </div>
    </div>
  );
};

export default AgentBioModal;
